import { render, staticRenderFns } from "./LeaveMessage.vue?vue&type=template&id=38bba333"
import script from "./LeaveMessage.vue?vue&type=script&lang=js"
export * from "./LeaveMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports